import React, { useState} from "react";
import parse from "html-react-parser";
import foods from "../data/foods.json";
import ReactCountryFlag from "react-country-flag";
import countryCodes from "../data/countryCodes.json";
import countryContinents from "../data/countryContinents.json";
import '../assets/sass/resume.scss';

import {
  ComposableMap,
  Geographies,
  Geography
} from "react-simple-maps";


function stringToColor(str) {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i) * (i+1);
    hash |= 0;
  }

  // Golden angle
  const hue = (Math.abs(hash) * 137.508) % 360;

  const lightness = [42, 54, 66];
  const saturation = [65, 80];

  const l =
    lightness[Math.abs(hash >> 8) % lightness.length];
  const s =
    saturation[Math.abs(hash >> 16) % saturation.length];

  return `hsl(${hue}, ${s}%, ${l}%)`;
}

function getRegionView(region) {
  const views = {
    World: {
      center: [0, 20],
      scale: 150
    },

    "North America": {
      center: [-100, 45],
      scale: 420
    },

    "Central America & Caribbean": {
      center: [-80, 18],
      scale: 900
    },

    "South America": {
      center: [-60, -18],
      scale: 550
    },

    Europe: {
      center: [20,55],
      scale: 600
    },

    "North Africa": {
      center: [30, 25],
      scale: 900
    },

    "Sub-Saharan Africa": {
      center: [20, -5],
      scale: 550
    },

    "Middle East": {
      center: [44, 35],
      scale: 1500
    },

    "South Asia": {
      center: [80, 22],
      scale: 1200
    },

    "Southeast Asia": {
      center: [106, 8],
      scale: 1200
    },

    "East Asia": {
      center: [120, 35],
      scale: 900
    },

    "Central Asia": {
      center: [68, 43],
      scale: 900
    },

    Oceania: {
      center: [145, -25],
      scale: 700
    }
  };

  return views[region] || views.World;
}


export default function Home() {

  const isMobile =
  typeof window !== "undefined" &&
  window.innerWidth < 768;

  const [selectedCountry, setSelectedCountry] =
    useState(null);

  const [showPopup, setShowPopup] =
    useState(false);

  const [selectedRegion, setSelectedRegion] =
    useState("World");

  const cookedCountries =
    new Set(
      foods.map(
        food => food.country
      )
    );

  const countryColors = {};

  [...cookedCountries].forEach(
    country => {
      countryColors[country] =
        stringToColor(country);
    }
  );

  const selectedFoods = foods.filter(
    food => food.country === selectedCountry
  );

  const filteredFoods =
  selectedRegion === "World"
    ? foods
    : foods.filter(
        food =>
          countryContinents[
            food.country
          ] === selectedRegion
      );


  const recipeCount = filteredFoods.length;

  const countryCount =
    new Set(
      filteredFoods.map(
        food => food.country
      )
    ).size;
  
const mapView =
  getRegionView(
    selectedRegion
  );

  return (
    <div>
      <h1>Foods Around the World</h1>

      <p
  style={{
    maxWidth: "900px",
    width: "90%",
    lineHeight: "1.8",
    fontSize: "clamp(0.95rem, 2vw, 1.05rem)",
    color: "#444",
    textAlign: "left",
  }}
>
This started as an experimental fun project around mid 2025, where I would randomly pick a country and make food from that country as my weekly meal prep. 
The exercise has led me to cook and eat more diverse food and experience flavor profiles that I did not grow up with. It has been lovely learning about 
new food ingredients, cooking styles, food histories, and noticing similarities and differences across geographies.<br/><br/>
The website is still work-in-progress. Right now, you can filter only by the continent. If you click on the color-coded countries you will get to see the food 
I have cooked from that country along with a short description. 
</p>

    <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "20px",
    flexWrap: "wrap"
  }}
>
  <div>
    <label
      style={{
        marginRight: "10px",
        fontWeight: "bold",
         marginLeft: "10px",
      }}
    >
      View:
    </label>

    <select
      value={selectedRegion}
      onChange={e =>
        setSelectedRegion(e.target.value)
      }
    >
      <option>World</option>

      <option>North America</option>
      <option>Central America & Caribbean</option>
      <option>South America</option>

      <option>Europe</option>

      <option>North Africa</option>
      <option>Sub-Saharan Africa</option>

      <option>Middle East</option>

      <option>South Asia</option>
      <option>Southeast Asia</option>
      <option>East Asia</option>
      <option>Central Asia</option>

      <option>Oceania</option>
    </select>
  </div>

  <div
    style={{
      padding: "6px 12px",
      background: "#f5f5f5",
      borderRadius: "8px",
      border: "1px solid #ddd",
      display: "flex",
      flexWrap: "wrap",
      gap: "10px",
      alignItems: "center"
    }}
  >
    🍽️ Recipes: {recipeCount}
  </div>

  <div
    style={{
      padding: "6px 12px",
      background: "#f5f5f5",
      borderRadius: "8px",
      border: "1px solid #ddd",
      display: "flex",
      flexWrap: "wrap",
      gap: "10px",
      alignItems: "center"
    }}
  >
    🌍 Countries: {countryCount}
  </div>
</div>

  <ComposableMap
    width={1000}
    height={600}
    style={{
      width: "100%",
      height: "auto"
    }}
    projection="geoMercator"
    projectionConfig={{
    center: mapView.center,
    scale: mapView.scale
  }}
  >

  <Geographies geography="/maps/world.geojson">
          {({ geographies }) =>
            geographies.map(geo => {
              const countryName =
                geo.properties.ADMIN ||
                geo.properties.NAME ||
                geo.properties.name;

              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill={
                    countryColors[countryName] ||
                    "#E0E0E0"
                  }
                  stroke={
                    countryColors[countryName]
                      ? "#000000"
                      : "#CCCCCC"
                  }

                  strokeWidth={
                    countryColors[countryName]
                      ? 0.3
                      : 0
                  }
                  style={{
                    default: {
                      outline: "none"
                    }
                  }}
                  onClick={() => {
                    if (
                      cookedCountries.has(countryName)
                    ) {
                      setSelectedCountry(
                        countryName
                      );
                      setShowPopup(true);
                    }
                  }}
                />
              );
            })
          }
        </Geographies>
  </ComposableMap>

      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background:
              "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
          }}
          onClick={() =>
            setShowPopup(false)
          }
        >
          <div
            style={{
              background: "white",
              width: "90%",
              maxWidth: "800px",
              maxHeight: "80vh",
              overflowY: "auto",
              borderRadius: "10px",
              padding: "20px"
            }}
            onClick={e =>
              e.stopPropagation()
            }
          >
          <div style={{ marginBottom: "20px" }}>
            <h2 style={{ margin: 0 }}>
              {selectedCountry}
            </h2>

            {countryCodes[selectedCountry] && (
              <ReactCountryFlag
                countryCode={countryCodes[selectedCountry]}
                svg
                style={{
                  width: "40px",
                  height: "30px",
                  marginTop: "8px"
                }}
              />
            )}
          </div>

            <button
              onClick={() =>
                setShowPopup(false)
              }
            >
              Close
            </button>

            {selectedFoods.map(food => (
              <div
                key={food.id}
                style={{
                  border: "1px solid #ddd",
                  padding: "15px",
                  marginTop: "15px",
                  borderRadius: "8px",
                  display: "flex",
                  gap: "20px",
                  alignItems: "flex-start"
                }}
              >
              <div
                style={{
                  display: "flex",
                  flexDirection:
                    isMobile
                      ? "column"
                      : "row",
                  gap: "20px"
                }}
              >
                <img
                  src={food.image}
                  alt={food.foodName}
                  style={{
                    width: "50%",
                    maxWidth: "200px",
                    borderRadius: "8px",
                    border: "1px solid black",
                    objectFit: "cover"
                  }}
                />

                <div style={{ flex: 1 }}>
                  <h3>{food.foodName}</h3>
              
                    <div>
                      {parse(food.description)}
                    </div>
                </div>
              </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export const Head = () => (
  <>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1"
    />
    <title>
      Foods Around the World
    </title>
  </>
);